// extracted by mini-css-extract-plugin
module.exports = {"bb-funders":"bb-funders__cFQYp"};